import './addCoursePricing.scss'
import { ErrorMessage, Form, Formik } from 'formik'
import * as Yup from 'yup'
import useScreenSize from '../../hooks/useScreenSize'
import Button from '../../components/button/Button'
import NewInput from '../../components/input/NewInput'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import rupeeIcon from '../../assets/icons/rupeeIconBlack.svg'
import { useEffect, useState } from 'react'
import { ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { useNavigate, useParams } from 'react-router-dom'
import { convertDateFormat, handleInput } from '../../utility/genricFunction'
import { useDispatch, useSelector } from 'react-redux'
import {
  createCourseFees,
  getBatchList,
  getBranchList,
  getCourseByCourseId,
  getCoursePricing,
} from '../../store/builders/course/course.builder'
import { resetCourseFees } from '../../store/slice/course/course.slice'
import { toast } from 'react-toastify'
import Loader from '../../components/loader/Loader'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages'

function AddCoursePricing() {
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const screenSize = useScreenSize()
  const [disabled, setDisabled] = useState(true)

  const [initialValues] = useState({
    branchName: '',
    batchName: '',
    oneShotPay: '',
    installmentPay: '',
  })
  const { courseId, branchList, batchList, courseFees, loading, currentCourse, pageDropDownLoading } = useSelector((store) => {
    return store.course
  })



  useEffect(() => {
    dispatch(getBranchList('active'))
    dispatch(getCourseByCourseId(id))
    const handleBeforeUnload = () => {
      dispatch(resetCourseFees())
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [courseId, dispatch, id])

  const handleBranchDropdownChange = (value, setFieldValue) => {
    setFieldValue('branchName', value)
    dispatch(resetCourseFees())
    if (courseId && !id) {
      dispatch(getBatchList({ value, courseId }))
      dispatch(getCoursePricing({ courseId, branchId: value }))
    }

    if (id) {
      dispatch(getBatchList({ value, courseId: id }))
      dispatch(getCoursePricing({ courseId: id, branchId: value }))
    }
  }

  const handleBatchDropDownChange = (value, setFieldValue) => {
    setFieldValue('batchName', value)
  }

  const AddCoursePricingSchema = Yup.object().shape({
    branchName: Yup.string().required(VALIDATION_MESSAGES.BRANCH_REQUIRED),
    batchName: Yup.string().required(VALIDATION_MESSAGES.BATCH_REQUIRED),
    oneShotPay: Yup.string()
      .matches(/^[0-9]*$/, VALIDATION_MESSAGES.ONE_SHOT_PAY_VALID)
      .required(VALIDATION_MESSAGES.ONE_SHOT_PAY_REQUIRE),
    installmentPay: Yup.string()
      .matches(/^[0-9]*$/, VALIDATION_MESSAGES.INTALLMENT_PAY_VALID)
      .required(VALIDATION_MESSAGES.INSTALLMENT_PAY_REQUIRE),
  })

  const branchOptions = branchList.map((branch) => {
    return { label: branch.branchName, value: branch.branchId }
  })

  const batchOptions = batchList.map((branch) => {
    return { label: branch.batchNo, value: branch.batchId }
  })

  const breadCrumbsArr = id
    ? [
      {
        title: UI_CONSTANT.COURSE.EDIT_COURSE,
        link: null,
      },
      {
        title: UI_CONSTANT.DASHBOARD,
        link: ROUTES_PATH.DASHBOARD,
      },
      {
        title: UI_CONSTANT.COURSE.LABLE_COURSE,
        link: ROUTES_PATH.COURSE,
      },
      {
        title: UI_CONSTANT.COURSE.EDIT_COURSE_PRICING,
        link: ROUTES_PATH.EDIT_COURSE_PRICING.replace(':id', id),
      },
    ]
    : [
      {
        title: UI_CONSTANT.COURSE.ADD_COURSE,
        link: null,
      },
      {
        title: UI_CONSTANT.DASHBOARD,
        link: ROUTES_PATH.DASHBOARD,
      },
      {
        title: UI_CONSTANT.COURSE.LABLE_COURSE,
        link: ROUTES_PATH.COURSE,
      },
      {
        title: UI_CONSTANT.COURSE.COURSE_INFORMATION,
        link: ROUTES_PATH.ADD_COURSE_INFORMATION,
      },
      {
        title: UI_CONSTANT.COURSE.COURSE_CONTENT,
        link: ROUTES_PATH.ADD_COURSE_CONTENT,
      },
      {
        title: UI_CONSTANT.COURSE.COURSE_PRICING,
        link: ROUTES_PATH.ADD_COURSE_PRICING,
      },
    ]

  return (
    <>
    {loading && <Loader loading={loading} />}
    {<Loader loading={loading} /> &&   <Formik
      initialValues={initialValues}
      validationSchema={AddCoursePricingSchema}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false)
        }, 400)
      }}
      enableReinitialize
    >
      {({ values, resetForm, validateForm, setTouched, setFieldValue }) => (
        <div className={`add-pricing-course-list ${screenSize}`}>

        {loading && <Loader></Loader>}

          <div className='filter-bar-wraper-sticky'>
            <div className='add-course-info-course'></div>
            <div className='course-add-pricing-subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
              <div>
                <Button
                  disabled={disabled}
                  className={'btn-publish'}
                  onClick={() => {
                    navigate(ROUTES_PATH.COURSE)
                    toast.success('Course published Successfully', {
                      className: 'custom-toast-success',
                      progressStyle: { background: '#428D56' },
                    })
                  }}
                >
                  {id ? UI_CONSTANT.SAVE : UI_CONSTANT.PUBLISH}
                </Button>
              </div>
            </div>
          </div>
          <Form>
            <div className='add-course-content-group-parent'>
              <div className='pricing-header'>
                <b className='course-information-heading'>{UI_CONSTANT.COURSE.COURSE_PRICING}</b>
                <p className='course-info-subHeading'>{UI_CONSTANT.COURSE.FORM_DESCRIPTION}</p>
                {batchList?.length === 0 && (
                  <div className='batch-warning-div'>
                    Kindly add batches to your branch in order to proceed with adding course price
                  </div>
                )}
              </div>
              <div className='pricing-div-wrapper'>
                <div className='pricing-input-fields'>
                  <div>
                    <label htmlFor=''>Branch</label>
                    <span className='required-symbol'>*</span>
                  </div>
                  <PageDropdown
                    options={branchOptions}
                    selectedValue={values.branchName}
                    name='branchName'
                    className='pricing-dropdown'
                    onChange={(e) => handleBranchDropdownChange(e.target.value, setFieldValue)}
                    placeholder='Select Branch'
                  />
                  <ErrorMessage name='branchName' component='div' className='error-msg' />
                </div>

                <div className='pricing-input-fields'>
                  <div>
                    <label htmlFor=''>Batch</label>
                    <span className='required-symbol'>*</span>
                  </div>

                  <PageDropdown
                    options={batchOptions}
                    selectedValue={values.batchName}
                    onChange={(e) => handleBatchDropDownChange(e.target.value, setFieldValue, values)}
                    name='batchName'
                    className='pricing-dropdown'
                    placeholder='Select Batch'
                  />
                  <ErrorMessage name='batchName' component='div' className='error-msg' />
                </div>
                <div className='rupee-icon-wrapper'>
                  <img src={rupeeIcon} alt='rupee icon' className='rupee-icon' />
                  <NewInput
                    label='One Shot Pay'
                    width='100%'
                    type='text'
                    name='oneShotPay'
                    placeholder=''
                    fieldClassName='pricing-input-field'
                    onInput={handleInput}
                    required={true}
                    maxLength={6}
                  />
                </div>
                <div className='rupee-icon-wrapper'>
                  <img src={rupeeIcon} alt='rupee icon' className='rupee-icon' />
                  <NewInput
                    label='Installment Pay'
                    width='100%'
                    type='text'
                    name='installmentPay'
                    placeholder=''
                    fieldClassName='pricing-input-field'
                    onInput={handleInput}
                    required={true}
                    maxLength={6}
                  />
                </div>

                <Button
                  type='button'
                  customClassName='add-btn-course-pricing'
                  disabled={batchList.length === 0}
                  onClick={async () => {
                    const errors = await validateForm()
                    setTouched({
                      branchName: true,
                      batchName: true,
                      oneShotPay: true,
                      installmentPay: true,
                    })

                    if (!errors.branchName && !errors.batchName && !errors.installmentPay && !errors.oneShotPay) {
                      resetForm()
                      const branchNames = currentCourse.course_branches.map((branch) => branch.branch.branch_id)
                      if (courseId && !id) return dispatch(createCourseFees({ ...values, courseId, dispatch }))
                      if (id) return dispatch(createCourseFees({ ...values, courseId: id, branchNames , dispatch}))
                    }
                  }}
                >
                  {UI_CONSTANT.ADD}
                </Button>
              </div>
              <div className='date-reflection-information'>
                This fees will be reflected from the selected batch start date
              </div>

              {courseFees.length > 0 ? (
                (setDisabled(false),
                  (
                    <table className='branch-list-container'>
                      <tr className='title-row'>
                        <td className='col-width-200'>BRANCH NAME</td>
                        <td className='col-width-200'>BATCH NAME</td>
                        <td className='col-width-200'>ONESHOT PRICE</td>
                        <td className='col-width-200'>INSTALLMENT PRICE</td>
                        <td className='col-calender'>REFLECTED DATE</td>
                      </tr>
                      {courseFees.map((branch, index) => {
                        return (
                          <tr className='branch-added-details' key={index}>
                            <td>{branch?.branchName}</td>
                            <td>{branch?.batchNo}</td>
                            <td>
                              <div>&#8377; {branch.oneShotPay}</div>
                            </td>
                            <td>
                              <div>&#8377; {branch.installmentPay}</div>
                            </td>
                            <td>{convertDateFormat(branch.batchDate)}</td>
                            <td className='col-width-500'></td>
                          </tr>
                        )
                      })}
                    </table>
                  ))
              ) : (
                <div className='branch-list-container no-fees-added'>No Fees Added for this Batch</div>
              )}
            </div>
          </Form>
        </div>
      )}
    </Formik>}
    </>
  )
}

export default AddCoursePricing
